import { NameSearchMode } from '@neptune/shared/search-domain';

export type TextFilter = {
  searchType: NameSearchMode.SUBSTRING;
  value: string;
};

export type CompoundSearchFilter = {
  searchType: NameSearchMode.REGEX;
  value: CompoundSearchCriterion[];
};

const COMPOUND_CRITERION_TYPES = ['regex', 'operator', 'lparen', 'rparen'] as const;

export type CompoundSearchCriterionType = (typeof COMPOUND_CRITERION_TYPES)[number];

export type CompoundSearchCriterion = {
  type: CompoundSearchCriterionType;
  value: string;
};

const isCompoundSearchCriterion = (value: unknown): value is CompoundSearchCriterion => {
  return (
    typeof value === 'object' &&
    value !== null &&
    'type' in value &&
    COMPOUND_CRITERION_TYPES.includes(value.type as any) &&
    'value' in value &&
    typeof (value as { value: unknown }).value === 'string'
  );
};

export const isArrayOfCompoundSearchCriterion = (
  value: unknown,
): value is CompoundSearchCriterion[] => {
  return Array.isArray(value) && value.every(isCompoundSearchCriterion);
};

export type ComplexSearchFilter = TextFilter | CompoundSearchFilter;

export abstract class ComplexSearchFilterConverter {
  static fromChartFilter(value: string): ComplexSearchFilter {
    return { searchType: NameSearchMode.SUBSTRING, value };
  }

  static fromRegexCriterions(value: CompoundSearchCriterion[]): ComplexSearchFilter {
    return { searchType: NameSearchMode.REGEX, value };
  }
}

export function isTextFilter(filter?: ComplexSearchFilter): filter is TextFilter {
  return filter?.searchType === NameSearchMode.SUBSTRING;
}

export function isRegexFilter(filter?: ComplexSearchFilter): filter is CompoundSearchFilter {
  return filter?.searchType === NameSearchMode.REGEX;
}
